<template>
    <div class="conversation-wrapper" v-if="activeConversation?.id">
        <header
            :class="`conversation-header px-3 py-2 d-flex jusitfy-content-center align-items-center ${
                isCallOngoing ? 'active-call-header' : ''
            }`"
        >
            <ConversationHeader />
        </header>
        <div class="conversation-body">
            <div
                v-if="activeConversation?.isDraftConversation"
                class="d-flex h-100 bg-white justify-content-center flex-column text-center"
            >
                <h4>You're starting a new conversation</h4>
                <p>Type your first message below.</p>
            </div>
            <div v-if="showRepliedMsgLoader" class="messages-loading-overlay">
                <div class="loader-parent">
                    <div class="msg-loader"></div>
                </div>
            </div>
            <MessagesRenderer />
        </div>
        <div v-if="activeConversation?.id" class="conversation-input">
            <ChatSummerEditor :key="activeConversationId" />
        </div>
    </div>
    <div
        v-if="!activeConversation?.id && !activeConversation?.isDraftConversation"
        class="d-flex h-100 bg-white justify-content-center flex-column text-center"
    >
        <h4>Welcome to Axxess Connect — your internal messaging solution.</h4>
        <p>Start a conversation to share updates, ask questions, or connect with your team.</p>

        <p>Clear communication drives great teamwork—and this is where it happens. Stay connected anywhere.</p>
        <p>Download the Axxess Central Mobile App to message your team on the go.</p>
    </div>
</template>
<script lang="ts" src="./Conversation.ts"></script>
